import { RoleEnum,  WORKFLOW_GROUP } from "@/model/enum/role-enum"

interface FilterOptionEnum {
  label: string
  value: number
  permissions?: RoleEnum[]
}

const filterOptionList: FilterOptionEnum[] = [
  {
    value: 1,
    label: "parcels.parcel_list.office_parcels"
  },
  {
    value: 2,
    label: "parcels.parcel_list.only_my_parcels",
    permissions: WORKFLOW_GROUP
  },
  {
    value: 3,
    label: "parcels.parcel_list.company_parcels"
  }
]

export {
  FilterOptionEnum,
  filterOptionList
}
